import React from 'react';
import { useGetContainer } from 'api/container';
import { GetContainerParams, Container } from 'api/container/container.types';
import { EditableAutocomplete } from './EditableAutocomplete';

interface EditableContainerTypeAutocompleteProps {
  value: any;
  onChange: (value: any) => void;
  onSave: (value: any) => void;
  onCancel: () => void;
  disableClearable?: boolean;
}

export const EditableContainerTypeAutocomplete: React.FC<
  EditableContainerTypeAutocompleteProps
> = ({ disableClearable = false, ...props }) => (
  <EditableAutocomplete<Container, GetContainerParams>
    {...props}
    disableClearable={disableClearable}
    useApiHook={useGetContainer}
    getterName='getContainer'
    defaultParams={{
      filterText: '',
      pageNumber: 1,
    }}
    mapOptions={(data) =>
      data.map((container) => ({
        id: container.id,
        code: container.code,
        enabled: container.enabled,
      }))
    }
    getOptionLabel={(o) => (typeof o === 'string' ? o : o.code || '')}
    isOptionEqualToValue={(option, selectedValue) =>
      selectedValue?.id === option?.id
    }
    deduplicateOptions={true}
    deduplicateKey='id'
  />
);
